<template>
  <div>
    <!--双床房选择-->
    <div class="city-list">
        <div class="city-list-tab">
            <div v-for="(item) in twinRoomQuantity" :key="item.name" :class="item.selected?'active':'other'"  @click.stop="changeCity(item.id)">
                {{ item.name }}
            </div>
        </div>
        <div class="city-list-btn">
          <div class="reset" @click="resetCity">重置</div>
          <div class="determine" @click="dateConfirm">确定</div>
        </div>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
export default {
  name: 'StarRating',
  components: {},
  props: {},
  data() {
    return {
      twinRoomQuantity: [
        ...this.$GVAR.twinRoomQuantity.map(item => ({...item,selected:false}))
      ],
      cityIndex:0,
      star:[],
    };
  },
  computed: {},
  watch: {},
  created() {
  },
  mounted() {

  },
  methods: {
    //判断点击是否选中
    changeCity(id){
    this.twinRoomQuantity.forEach((item,index) => {
        if(item.id==id){
             item.selected=!item.selected;
        }else{
             item.selected=false;
        }
      });
    },
    //重置
    resetCity(){
      this.twinRoomQuantity.forEach(item => {
        item.selected=false;
      });
    },
    //确定
    dateConfirm(){
        let room_2_type=[];
        this.twinRoomQuantity.forEach(item => {
            if(item.selected){
                room_2_type=item.id;
            }
        });
        this.$emit('formData',{room_2_type});
    },
  }
};
</script>

<style lang="scss" scoped>
.city-list{
    position: absolute;
    top: 70px;
    left: 0;
    width: 296px;
    background-color: #Fff;
    border-radius: 6px;
    box-shadow: 0 2px 9px #999;
    z-index: 9;
}
.city-list::after {
  content: "";
  position: absolute;
  top: -12px;     /* 贴在底部 */
  left: 70px;     /* 水平居中 */
  margin-left: -6px;
  width: 0;
  height: 0;
  border-width: 6px;
  border-style: solid;
  border-color: transparent transparent #ffffff transparent;
}
.city-list-tab{
  width: 96%;
  color: #4a5565;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: 0 auto;
}
.city-list-tab div{
  width: 48%; 
  text-align: center;
  padding: 8px 0;
  border-radius: 50px;
  margin-top: 12px;
  background-color: #f3f4f6;
  font-size: 12px;
  cursor: pointer;
}
.city-list-tab .other:hover{
  background-color: #e5e7eb;
}
.city-list-btn{
  border-top: 1px #eee solid;
  margin-top: 12px;
  color: #333;
  display: flex;
  width: 96%;
  padding: 3% 2%;
  justify-content:right;
  div{
    cursor: pointer;
  }
}
.determine{
  background-color: var(--smtc-color-primary);
  color:#fff;
  padding: 8px 36px;
  font-size: 13px;
  border-radius: 20px;
}
.reset{
  margin-right: 10px;
  padding: 8px 10px;
   font-size: 13px;
  border-radius: 50px;
}
.city-list-tab .active{
  background-color: var(--smtc-color-primary);
  color: #Fff;
}
</style>
